import { IResource } from '@torim-app/types';
import { adminUrlBuilder } from '@app/api/utils';

export class ResourcesApi {
  static readonly path = 'resources';

  private static async request<T>(subPath: string, method: string, body?: unknown): Promise<T> {
    const url = adminUrlBuilder({}, subPath ? `${ResourcesApi.path}/${subPath}` : ResourcesApi.path);
    const response = await fetch(url, {
      method,
      headers: { 'content-type': 'application/json' },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    if (!response.ok) throw `Failed resources request: ${subPath || method}`;
    return (await response.json()) as T;
  }

  static getResources(): Promise<IResource[]> {
    return ResourcesApi.request<IResource[]>('', 'get');
  }

  static upsertResource(resource: Partial<IResource>): Promise<IResource> {
    return ResourcesApi.request<IResource>('', 'put', resource);
  }

  static deleteResource(resourceId: string): Promise<{ success: boolean }> {
    return ResourcesApi.request<{ success: boolean }>(resourceId, 'delete');
  }
}
